<template lang="pug">
    v-flex
      v-menu(ref='menu' v-model='menu' :close-on-content-click='false' :nudge-right='40' :return-value.sync='dates' transition='scale-transition' offset-y min-width='290px')
        template(v-slot:activator='{ on }')
          v-combobox(v-model='dates' multiple chips small-chips label='Rango de fechas' prepend-icon='fa-calendar-day' readonly v-on='on')
        v-date-picker(v-model='dates' multiple no-title scrollable)
          v-spacer
          v-btn( color='primary' @click='cleanLookingFor()') Cancel
          v-btn( color='primary' @click='lookingFor(dates)') OK  
</template>

<script>
  export default {
    data: () => ({
      dates: [],
      menu: false
    }),
    props:{
      type: String,
      data: Object,
    },
    watch:{
      'dates'(){
        (this.dates.length > 2 ) ? this.$delete(this.dates, 0) : null
        if (this.dates[0]>this.dates[1]) {
          this.dates[2] = this.dates[0]
          this.$delete(this.dates, 0)
        }
      }
    },
    methods:{
      cleanLookingFor(){
        this.$store.state[this.type].searchingDate = []
        this.$store.dispatch(this.type+'/getAll', this.data)
        this.menu = false
        this.$refs.menu.save([])
      },
      lookingFor(dates){
        this.$store.state[this.type].searchingDate = this.dates
        this.$store.dispatch(this.type+'/lookingForDates', this.data)
        this.menu = false
        this.$refs.menu.save(dates)
      }
    }
  }
</script>